import React from 'react';
import { Star, Quote } from 'lucide-react';
interface TestimonialProps {
  initials: string;
  name: string;
  role: string;
  location: string;
  text: string;
  highlight?: string;
}
const TestimonialCard = ({
  initials,
  name,
  role,
  location,
  text,
  highlight
}: TestimonialProps) => <div className="bg-zinc-900 border-2 border-brand-green/40 rounded-xl p-4 md:p-5 shadow-xl flex flex-col h-full hover:border-brand-green transition-colors relative" data-id="element-288">
    <Quote className="absolute top-3 right-3 w-6 h-6 text-brand-green/30" data-id="element-289" />

    <div className="flex items-center mb-3" data-id="element-290">
      <div className="w-10 h-10 md:w-12 md:h-12 bg-gradient-to-br from-brand-green to-brand-greenDark text-white rounded-full flex items-center justify-center font-display font-bold text-base md:text-lg mr-2.5 shrink-0 shadow-md ring-2 ring-brand-green/40" data-id="element-291">
        {initials}
      </div>
      <div data-id="element-292">
        <p className="font-display font-bold text-white text-sm md:text-base leading-tight" data-id="element-293">
          {name}
        </p>
        <p className="text-[11px] md:text-xs text-brand-greenLight font-semibold" data-id="element-294">
          {role}
        </p>
        <p className="text-[10px] md:text-xs text-zinc-400" data-id="element-295">📍 {location}</p>
      </div>
    </div>

    <div className="flex text-brand-yellow mb-2.5" data-id="element-296">
      {[...Array(5)].map((_, i) => <Star key={i} className="w-3.5 h-3.5 fill-current" data-id="element-297" />)}
    </div>

    <p className="text-xs md:text-sm text-zinc-300 italic flex-grow leading-relaxed" data-id="element-298">
      "{text}"
    </p>

    {highlight && <div className="mt-3 pt-3 border-t border-brand-green/30" data-id="element-299">
        <p className="text-[11px] md:text-xs font-bold text-brand-greenLight uppercase" data-id="element-300">
          ✅ {highlight}
        </p>
      </div>}
  </div>;
export function TestimonialsSection2() {
  const testimonials = [{
    initials: 'MF',
    name: 'Martín Ferreyra',
    role: 'Productor Ganadero',
    location: 'Entre Ríos, Argentina',
    text: 'Con solo reorganizar parte de los corrales usando uno de los sistemas del pack, ya notamos menos estrés y mejor circulación.',
    highlight: 'Menos estrés, mejor circulación'
  }, {
    initials: 'RH',
    name: 'Ramón Herrera',
    role: 'Productor Ganadero · 54 años',
    location: 'Salta, Argentina',
    text: 'Tengo 480 cabezas y siempre trabajé con corrales que armé yo a ojo. Adapté el diseño con manga curva y la carga de hacienda ahora me lleva la mitad de tiempo. Mi peón también lo agradeció.',
    highlight: 'Carga 50% más rápida'
  }, {
    initials: 'HB',
    name: 'Hugo Barrera',
    role: 'Productor Ganadero · 52 años',
    location: 'Tandil, Buenos Aires',
    text: 'Estaba por contratar a un ingeniero para que me diseñe un corral. Por suerte un vecino me pasó este sistema antes. Encontré tres configuraciones que se adaptaban a mi terreno. Ahorré una fortuna y funciona perfecto.',
    highlight: 'Ahorró en diseño profesional'
  }, {
    initials: 'NM',
    name: 'Néstor Mansilla',
    role: 'Encargado de Estancia · 45 años',
    location: 'La Pampa, Argentina',
    text: 'Trabajo hace 20 años en el campo y nunca había visto un material tan práctico. Construimos un embarcadero siguiendo el sistema y la pérdida de tiempo en cargas a camión bajó un montón.',
    highlight: 'Embarque más eficiente'
  }, {
    initials: 'EF',
    name: 'Eduardo Fernández',
    role: 'Productor Ganadero · 49 años',
    location: 'Santiago del Estero, Argentina',
    text: 'Compré el pack premium hace dos meses. La guía de manejo eficiente me cambió la forma de organizar el trabajo semanal. Antes corría todo el día sin terminar nada, ahora tengo una rutina clara.',
    highlight: 'Rutina semanal organizada'
  }];
  return <section className="py-10 md:py-14 px-4 bg-zinc-950" data-id="element-301">
      <div className="max-w-5xl mx-auto" data-id="element-302">
        <div className="text-center mb-8 md:mb-10" data-id="element-303">
          <div className="inline-flex items-center gap-1.5 bg-brand-yellow text-brand-ink font-bold px-3.5 py-1 rounded-full mb-3 uppercase tracking-wider text-[11px] md:text-xs shadow-md" data-id="element-304">
            <Star className="w-3.5 h-3.5 fill-current" data-id="element-305" /> Lo que dicen los
            productores
          </div>
          <h2 className="text-2xl md:text-4xl font-display font-bold text-white uppercase leading-tight" data-id="element-306">
            Más Productores que{' '}
            <span className="highlight-green" data-id="element-307">Ya Cambiaron</span> Su Manejo
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5" data-id="element-308">
          {testimonials.map((t, i) => <TestimonialCard key={i} {...t} data-id="element-309" />)}
        </div>
      </div>
    </section>;
}